/**
 * Owner: Masa Bayu
 * File: aliases.ts
 * Date:Time: 2026-09-19 15:48
 * Description: Deprecated BCP 47 language aliases → canonical (GL-01).
 */
/** Legacy / deprecated primary subtags → canonical primary (BCP 47 grandfathered / aliases). */
export const QX_LANGUAGE_PRIMARY_ALIASES = Object.freeze({
    iw: 'he',
    in: 'id',
    ji: 'yi',
    jw: 'jv',
    mo: 'ro',
    sh: 'sr',
    tl: 'fil',
});
export function resolvePrimaryAlias(primary) {
    const key = primary.toLowerCase();
    const canonical = QX_LANGUAGE_PRIMARY_ALIASES[key];
    if (canonical === undefined) {
        return Object.freeze({
            canonical: key,
            wasAlias: false,
            deprecatedFrom: null,
        });
    }
    return Object.freeze({
        canonical,
        wasAlias: true,
        deprecatedFrom: key,
    });
}
//# sourceMappingURL=aliases.js.map